// eslint-disable-next-line jira/import-whitelist
import { transformUrlToAddonAndModuleKeys } from '@jira/platform__legacy-connect-iframe/src/services/transformers.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_CONNECT_PROJECT = 'CONNECT_PROJECT';

/* oxlint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line jira/router/no-daisy-chaining-resources
export const connectProjectResources: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_CONNECT_PROJECT,
	getKey: ({ query }) => {
		const { addonKey, moduleKey } = transformUrlToAddonAndModuleKeys(query);

		if (addonKey !== '' && moduleKey !== '') {
			return `${addonKey}-${moduleKey}`;
		}
		return 'state';
	},
	depends: [staticProjectSidebarNavigationResource.type],
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-connect-addon-projects", jiraSpaEntry: "async-resource-connect-addon-projects" */ './getAddonData.tsx'
		),
});
/* oxlint-enable @typescript-eslint/no-explicit-any */
